import { BookOpen, LifeBuoy, MessageSquarePlus } from "lucide-react";
import { defineFeature } from "../types";

/**
 * Support — the agency's line to Lean2Automate about the product.
 *
 * Self-help articles and tickets for bugs and feature requests. Every member
 * can reach it: an agency that cannot tell its vendor something is broken
 * writes a bad review instead, so there is no permission on it.
 *
 * Not the client portal. That is how the agency's own clients reach the
 * agency; this is one level above, and the two must never be confused in the
 * navigation.
 */
export default defineFeature({
  key: "support",
  title: "Support",
  routes: [{ path: "support", lazy: () => import("./page") }],
  nav: [
    {
      label: "Support",
      to: "/support",
      icon: LifeBuoy,
      group: "workspace",
      order: 900,
      description: "Help articles, and tickets with Lean2Automate",
    },
  ],
  commands: [
    {
      key: "support.help",
      label: "Help centre",
      icon: BookOpen,
      to: "/support",
      group: "navigate",
      keywords: ["help", "faq", "docs", "how do i", "guide"],
    },
    {
      key: "support.ticket",
      label: "Report a problem or request a feature",
      icon: MessageSquarePlus,
      to: "/support?tab=tickets",
      group: "actions",
      keywords: ["bug", "support", "ticket", "broken", "feature request", "contact"],
    },
  ],
});
